import { render, staticRenderFns } from "./validation.vue?vue&type=template&id=03960ca6&scoped=true"
import script from "./validation.vue?vue&type=script&lang=js"
export * from "./validation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03960ca6",
  null
  
)

export default component.exports